 $('.scrolling-text').slick({
                          dots: false,
                          infinite: true,
                          centerMode: true,
                          speed: 3000,
                          slidesToShow: 4,
                          slidesToScroll: 1,
                          autoplay:true,
                          autoplaySpeed:0,
                          arrows: true,
                          cssEase:'Linear',
                          responsive: [
                            {
                              breakpoint: 1024,
                              settings: {
                                slidesToShow: 3
                              }
                            },
                            {
                              breakpoint: 991,
                              settings: {
                                slidesToShow: 3
                              }
                            },
                            {
                              breakpoint: 480,
                              settings: {
                                slidesToShow: 1
                              }
                            }

                          ]
                        });

                        $('.review_sec_wrapper').slick({
                          dots: false,
                          infinite: true,
                          centerMode: true,
                          speed: 300,
                          slidesToShow: 3,
                          slidesToScroll: 1,
                          arrows: true,
                          responsive: [
                            {
                              breakpoint: 1024,
                              settings: {
                                slidesToShow: 3
                              }
                            },
                            {
                              breakpoint: 991,
                              settings: {
                                slidesToShow: 2
                              }
                            },
                            {
                              breakpoint: 480,
                              settings: {
                                slidesToShow: 1
                              }
                            }

                          ]
                        });


                  $(document).ready(function() {
          // Initialize the Slick slider
          $('#video_slider').slick({
              dots: false,
              infinite: true,
              centerMode: true,
              speed: 300,
              autoplay: false, // Keep autoplay false for manual slider control
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: false,
              responsive: [
                  {
                      breakpoint: 1024,
                      settings: {
                          slidesToShow: 3
                      }
                  },
                  {
                      breakpoint: 767,
                      settings: {
                          slidesToShow: 1
                      }
                  }
              ]
          });

          // Set all videos to autoplay and mute, and show the correct buttons
          $('.custom_video_slider_col video').each(function() {
              $(this).prop('autoplay', true).prop('muted', true).get(0).play();
              $(this).siblings('.videoo_btn').find('.video_play_btn').show();
              $(this).siblings('.videoo_btn').find('.video_pause_btn').hide();
          });

          // Add click event listener to toggle play/pause
          $('.custom_video_slider_col video').on('click', function() {
              var video = $(this).get(0);
              var playButton = $(this).siblings('.videoo_btn').find('.video_play_btn');
              var pauseButton = $(this).siblings('.videoo_btn').find('.video_pause_btn');

              if (video.paused) {
                  video.play();
                  playButton.show();
                  pauseButton.hide();
              } else {
                  video.pause();
                  playButton.hide();
                  pauseButton.show();
              }
          });

          // Show play button when video ends
          $('.custom_video_slider_col video').on('ended', function() {
              var playButton = $(this).siblings('.videoo_btn').find('.video_play_btn');
              var pauseButton = $(this).siblings('.videoo_btn').find('.video_pause_btn');
              playButton.hide();
              pauseButton.show();
          });
      });